import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTracker } from '../utils/UsageTracker';
import Raven from 'raven-js';
import EPCsatSurvey from 'editor-components/survey/EPCsatSurvey';
import { getShowFeedbackTime, getHideFeedbackTime, setInFeedbackSession, getInFeedbackSession, getHasDismissedFeedback, setHasDismissedFeedback, getIsDeclinedDateOlderThanThreshold, getIsUserElligibleForFeedback } from 'ContentEditorUI/js/utils/PatagoniaFeedbackUtils';
import { getHasSeenEditorCsatCount
// @ts-expect-error not yet migrated
} from 'ContentEditorUI/js/redux/selectors/settingsSelectors';

// import UsageTracker from 'ContentEditorUI/utils/UsageTracker';

import { setHasSubmittedEditorCsat, updateHasSeenEditorCsatCount, setHasDeclinedEditorCsatToNow, resetHasSeenEditorCsatCount
// @ts-expect-error not yet migrated
} from 'ContentEditorUI/js/redux/actions/settingsActions';
import { getIsUngatedForUnifiedEditorCsat } from '../redux/selectors/authSelectors';
import { getEditorCsatSubmissionDateFromSuperstore, getEditorCsatDeclinedDateFromSuperstore
// @ts-expect-error not yet migrated
} from '../redux/selectors/localCachedSettingsSelectors';
import { fetchUser } from '../api/UsersApi';
import { jsx as _jsx } from "react/jsx-runtime";
const SurveyContainer = () => {
  //if feedback badge is left open while going to other apps or page gets refreshed keep it open
  const isInFeedbackSession = getInFeedbackSession();

  //if manually dismisses feedback badge before responding - dont show again till next session
  const hasDismissedFeedback = getHasDismissedFeedback();

  //if feedback badge has been displayed or closed total of 3 times without interaction do not show again
  const hasSeenEditorCsatCount = useSelector(getHasSeenEditorCsatCount);

  //does not show feedback badge if already has given feedback
  const editorCsatSubmissionDateFromCache = useSelector(getEditorCsatSubmissionDateFromSuperstore);
  const editorCsatDeclinedDate = useSelector(getEditorCsatDeclinedDateFromSuperstore);
  const [editorCsatSubmissionDate] = useState(editorCsatSubmissionDateFromCache);
  const [user, setUser] = useState(null);
  const isUserEligibleForFeedback = !!user && getIsUserElligibleForFeedback(user, editorCsatSubmissionDate, editorCsatDeclinedDate);
  const isUngatedForUnifiedEditorCsat = useSelector(getIsUngatedForUnifiedEditorCsat);
  const dispatch = useDispatch();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(isInFeedbackSession);
  const [hasSubmittedFeedback, setHasSubmittedFeedback] = useState(false);
  const shouldShowFeedbackButton = isUngatedForUnifiedEditorCsat && hasSeenEditorCsatCount < 3 && isUserEligibleForFeedback && !hasDismissedFeedback;
  useEffect(() => {
    // Reset the dismiss count if we have passed the resurvey date so that the user
    // can see the survey again
    if (editorCsatDeclinedDate && getIsDeclinedDateOlderThanThreshold(editorCsatDeclinedDate)) {
      dispatch(resetHasSeenEditorCsatCount());
    }
  }, [dispatch, editorCsatDeclinedDate]);
  useEffect(() => {
    fetchUser().then(fetchedUser => {
      setUser(fetchedUser);
    }).catch(e => {
      Raven.captureException(e);
    });
  }, []);
  const onDismissSurvey = useCallback(() => {
    setInFeedbackSession(false);
    if (!hasSubmittedFeedback) {
      dispatch(updateHasSeenEditorCsatCount());
      setHasDismissedFeedback(true);
      if (hasSeenEditorCsatCount + 1 === 3) {
        dispatch(setHasDeclinedEditorCsatToNow());
      }
    }
    setIsFeedbackOpen(false);
  }, [dispatch, hasSeenEditorCsatCount, hasSubmittedFeedback]);
  const usageTracker = useTracker();
  const onSubmitResponse = useCallback(csatResponse => {
    if (usageTracker) {
      usageTracker.track('contentEditorCsatResponse', {
        score: csatResponse.score,
        canContact: csatResponse.canContact,
        additionalFeedback: csatResponse.feedbackMessage
      });
    } else {
      Raven.captureMessage('Attempted to track a CSAT response with an uninitialized UsageTracker. The response has been ignored');
    }
    setHasSubmittedFeedback(true);
    dispatch(setHasSubmittedEditorCsat());
  }, [dispatch, usageTracker]);
  useEffect(() => {
    const showFeedbackTime = getShowFeedbackTime();
    const hideFeedbackTime = getHideFeedbackTime();
    let hideFeedbackTimeoutId;
    if (shouldShowFeedbackButton && !hasSubmittedFeedback) {
      setTimeout(() => {
        setIsFeedbackOpen(true);
        setInFeedbackSession(true);
      }, showFeedbackTime);
      hideFeedbackTimeoutId = setTimeout(() => {
        onDismissSurvey();
      }, hideFeedbackTime);
    }
    return () => {
      if (hideFeedbackTimeoutId) {
        clearTimeout(hideFeedbackTimeoutId);
      }
    };
  }, [hasSubmittedFeedback, onDismissSurvey, shouldShowFeedbackButton]);
  if (!shouldShowFeedbackButton || !isFeedbackOpen) {
    return null;
  } else {
    return /*#__PURE__*/_jsx(EPCsatSurvey, {
      onDismiss: onDismissSurvey,
      onSubmit: onSubmitResponse
    });
  }
};
export default SurveyContainer;